import React from 'react'
import { useSelector } from 'react-redux'
import { Redirect } from 'react-router-dom'
import { buildStage1Navigation } from './Stage1Navigation'

/** Retired overview bookmarks resolve to the first actually granted Stage 1 page. */
export default function Stage1Landing() {
  const menuData = useSelector(state => state.layout.menuData || [])
  const landingPath = buildStage1Navigation(menuData).landingPath
  return <Redirect to={landingPath || '/workbench'} />
}
